import { Box, Divider, Stack, Typography } from '@mui/material';
import { CreditSubmission, LenderProfile } from '@trnsact/trnsact-shared-types';
import { S3_BUCKET_NAME } from "../../../../config";


export const LenderInfo = ({
  lenderProfile,
  creditSubmission,
  commonClasses,
}: {
  lenderProfile: LenderProfile;
  creditSubmission: CreditSubmission;
  commonClasses: any,
}) => {

  return <Box className={commonClasses.lenderDealerContactInfoBlock}>
    <Stack className={commonClasses.infoRows} spacing={1} divider={<Divider />}>
      <Box className={commonClasses.infoRow}>
        <Typography fontWeight={500}>Financing Source</Typography>
        <Typography fontWeight={500}>{lenderProfile.name}</Typography>
      </Box>
      <Box className={commonClasses.infoRow}>
        <Typography>Contact</Typography>
        <Typography>{creditSubmission.lenderContactInfo?.[0]?.fullName/* creditSubmission.contact */}</Typography>
      </Box>
      <Box className={commonClasses.infoRow}>
        <Typography>Phone</Typography>
        <Typography>{creditSubmission.lenderContactInfo?.[0]?.phoneNumber/* creditSubmission.contactPhone */}</Typography>
      </Box>
      <Box className={commonClasses.infoRow}>
        <Typography>Email</Typography>
        <Typography>{creditSubmission.lenderContactInfo?.[0]?.email/* creditSubmission.contactEmail */}</Typography>
      </Box>
    </Stack>
    {lenderProfile.logo && <Box className={commonClasses.logoContainer}>
      <img
        style={{ maxWidth: '100%' }}
        src={`https://${S3_BUCKET_NAME}.s3-us-west-2.amazonaws.com/${lenderProfile.logo}`}
        alt="Lender Logo"
      />
    </Box>}
  </Box>
};
